const renderHiddenInput = (el, name, disabled, value) => {
  var _a;
  // From Ionic Framework
  let input = el.querySelector('input.aux-input');
  if (!input) {
    input = (_a = el.ownerDocument) === null || _a === void 0 ? void 0 : _a.createElement('input');
    input.type = 'hidden';
    input.classList.add('aux-input');
    el.appendChild(input);
  }
  input.disabled = disabled;
  input.name = name;
  input.value = value || '';
};

export { renderHiddenInput as r };
